import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import { allowedTabs } from "../constants/permissionCatalog";
import AddNewTournament from "../pages/dashboardPage/tournamentSettings/addNewTournament/AddNewTournament";
import AllTournaments from "../pages/dashboardPage/tournamentSettings/allTournaments/AllTournaments";
import EditTournament from "../pages/dashboardPage/tournamentSettings/editTournament/EditTournament";
import TournamentAccess from "../pages/dashboardPage/tournamentSettings/tournamentAccess/TournamentAccess";
import TournamentImages from "../pages/dashboardPage/tournamentSettings/tournamentImages/TournamentImages";
import AllTournamentDetailsTemplates from "../pages/dashboardPage/tournamentSettings/tournamentDetailsTemplates/allTournamentDetailsTemplates/AllTournamentDetailsTemplates";
import AddTournamentDetailsTemplate from "../pages/dashboardPage/tournamentSettings/tournamentDetailsTemplates/addTournamentDetailsTemplate/AddTournamentDetailsTemplate";
import EditTournamentDetailsTemplate from "../pages/dashboardPage/tournamentSettings/tournamentDetailsTemplates/editTournamentDetailsTemplate/EditTournamentDetailsTemplate";
import OneTournamentTables from "../pages/dashboardPage/tournamentTables/oneTournamentTables/OneTournamentTables";

// Tab id (permissionCatalog "tournaments") → its page.
const TAB_PAGES = {
  "all-tournaments": AllTournaments,
  "add-tournament": AddNewTournament,
  "details-templates": AllTournamentDetailsTemplates,
  "tournament-access": TournamentAccess,
  "tournament-images": TournamentImages,
};

const TournamentNavigator = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const can = (permission) => rolePermissions.includes(permission);
  const tabs = allowedTabs("tournaments", rolePermissions);
  const FirstTab = tabs[0] ? TAB_PAGES[tabs[0].id] : null;

  return (
    <Routes>
      {tabs.map((tab) => {
        const Page = TAB_PAGES[tab.id];
        return <Route key={tab.id} path={`/${tab.path}`} element={<Page />} />;
      })}
      {/* Not tabs: opened from inside a tab, with that action's permission. */}
      {can("update-tournaments") && (
        <Route path="/edit-tournament" element={<EditTournament />} />
      )}
      {can("view-tables") && (
        <Route path="/tournament-tables/:tournamentId" element={<OneTournamentTables />} />
      )}
      {can("control-tournament-templates") && (
        <Route
          path="/add-tournament-details-template"
          element={<AddTournamentDetailsTemplate />}
        />
      )}
      {can("control-tournament-templates") && (
        <Route
          path="/edit-tournament-details-template"
          element={<EditTournamentDetailsTemplate />}
        />
      )}
      {can("view-tournaments") && (
        // Search now lives on the tournaments list; keep old links working.
        <Route
          path="/search-one-tournament"
          element={<Navigate to="/dashboard/tournaments/show-all-tournaments" replace />}
        />
      )}
      {FirstTab && <Route path="*" element={<FirstTab />} />}
    </Routes>
  );
};

export default TournamentNavigator;
